<template>
  <div id="dropdown-table-action">
    <div class="dropdown">
      <button
        v-if="isLink"
        class="btn btn-sm btn-link dropdown-toggle anchor-link"
        type="button"
        data-bs-toggle="dropdown"
      >
        {{ dropdownText }}
      </button>
      <button
        v-else
        class="btn btn-sm btn-secondary dropdown-toggle"
        type="button"
        data-bs-toggle="dropdown"
      >
        {{ dropdownText }}
      </button>
      <div class="dropdown-menu">
        <button
          v-for="(item, idx) in items"
          :key="idx"
          class="dropdown-item"
          v-show="item.displayCondition ? item.displayCondition(row) : true"
          :disabled="item.isDisabled ? item.isDisabled(row) : false"
          href="javascript:void(0)"
          @click.prevent="item.action(row)"
        >
          <small>
            <font-awesome-icon v-if="item.icon" class="me-1" :icon="item.icon" />
            {{ item.text }}
          </small>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "dropdown-table-action",
  props: {
    isLink: {
      type: Boolean,
      default: false,
    },
    dropdownSize: {
      type: String,
      default: "sm",
    },
    dropdownText: {
      type: String,
      default: "Actions",
    },
    items: {
      type: Array,
      default: () => [],
    },
    // selected row
    row: {
      type: Object,
      default: () => ({}),
    },
    // selected index
    index: {
      type: Number,
      default: null,
    },
  },
  data: () => ({
    isShown: false,
  }),
  methods: {
    showDropdown() {
      this.isShown = !this.isShown;
    },
  },
};
</script>

<style lang="scss" scoped>
#dropdown-table-action {
  position: relative;
}
</style>
